import React from "react";
import banner1 from "../Assets/Images/sdg1.png";
import banner2 from "../Assets/Images/sdg5.png";
import banner3 from "../Assets/Images/sdg7.png";
import banner4 from "../Assets/Images/sdg10.png";
import banner5 from "../Assets/Images/sdg13.png";


function Work() {
  const workData = [
    {
      image: banner1,
      title: "Zero Poverty",
      description:
        "Strengthen community livelihoods through skills development, youth empowerment, climate-resilient initiatives, and economic inclusion programs.",
    },
    {
      image: banner2,
      title: "Gender Equality",
      description:
        "We champion the rights and leadership of women and girls.",
    },
    {
      image: banner3,
      title: "Affordable and clean Energy",
      description:
        "We promote sustainable energy solutions that reduce environmental degradation and improve livelihoods",
    },
    {
      image: banner4,
      title: "Reduced Inequalities",
      description:
        "We amplify the voices of marginalized communities, especially youth, women, persons with disabilities, and pastoralist communities. We advocate for inclusive policies and equitable access to resources and opportunities",
    },
    {
      image: banner5,
      title: "Climate Action",
      description:
        "We support environmental conservation initiatives, and use storytelling and film to drive climate accountability and resilience.",
    },
  ];

  return (
    <section className="bg-gray-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="text-center mb-14">
          <h2 className="text-xl md:text-2xl font-bold text-red-500 inline-block border-b-4 border-red-500">
            Our Work
          </h2>
          {/* <div className="w-20 h-[2px] bg-red-500 mx-auto mt-4"></div>
          <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
            We focus on key areas that drive social impact and empower communities
            in Isiolo and beyond.
          </p> */}
        </div>

        {/* Cards */}
        <div className="flex flex-wrap gap-8">

          {workData.map((item, index) => (
            <div
              key={index}
             className="w-full sm:w-[48%] md:w-[30%] bg-white shadow-md flex flex-col"
            >
              {/* Image */}
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-[220px] object-fit"
              />

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow text-justify">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {item.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed flex-grow">
                  {item.description}
                </p>

                {/* Button */}
                <button className="mt-6 border border-red-500 text-red-500 px-4 py-2 text-sm hover:bg-red-500 hover:text-white transition duration-300 self-start">
                  Learn More
                </button>
              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default Work;